import { PersonaType, Weld } from '@bechtel/types';
export interface WeldDetailActionsProps {
  weld: Weld;
  personaType?: PersonaType;
  createRodRequest: () => void;
  isVisibleOnWeldSubHeader?: boolean;
}
